export enum AudiencesActionTypes {
    START_REQUEST = 'START_AUDIENCE_REQUEST',
    END_REQUEST = 'END_AUDIENCE_REQUEST',
    GET_AUDIENCES_ERROR = 'GET_AUDIENCES_ERROR',
    GET_AUDIENCES_SUCCESS = 'GET_AUDIENCES_SUCCESS',
    LOAD_AUDIENCES_SUCCESS = 'LOAD_AUDIENCES_SUCCESS',
    CREATE_AUDIENCE_SUCCESS = 'CREATE_AUDIENCE_SUCCESS',
    UPDATE_AUDIENCE_SUCCESS = 'UPDATE_AUDIENCE_SUCCESS'
}
